import React from "react";
import styles from "./NewsletterModal.module.css";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import { FaRegPaperPlane } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

const NewsletterModal = ({
  title = "Newsletter – July 2025",
  greeting = "Hi [First Name],",
  intro = "We hope you're having a fantastic start to your summer! Here's what's new and exciting this month at [Company Name]:",
  sections = [],
  sender = "Varun Sir",
  createdOn = "01/07/2025",
}) => {
  const dispatch = useDispatch();

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <HeadingAndIcon icon={<FaRegPaperPlane />} heading="Newsletter" />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.contentBox}>
        <p>
          <strong>{title}</strong>
        </p>
        <p>{greeting}</p>
        <p>{intro}</p>

        {sections.map((section, index) => (
          <div key={index} className={styles.section}>
            {section.icon && <span>{section.icon}</span>}
            <strong>{section.heading}</strong>
            {section.items?.map((item, idx) => (
              <div key={idx} className={styles.item}>
                <p>
                  {idx + 1}. {item.title}
                </p>
                <p>{item.description}</p>
                {item.link && (
                  <p>
                    Read it here →{" "}
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      [Link]
                    </a>
                  </p>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>

      <div className={styles.footerRow}>
        <span>
          Created By <br />
          <strong>{sender}</strong>
        </span>
        <span>
          Created On <br />
          <strong>{createdOn}</strong>
        </span>
      </div>
    </div>
  );
};

export default NewsletterModal;
